import { RemoteImageObject } from '@gem/modules/remote-storage';

import Entities from 'STORE';

export async function preloadImage(url: string): Promise<boolean> {
  if (!url || Entities.CachedImages.isCachedImage(url)) {
    return false;
  }

  return new Promise((resolve) => {
    const img = new RemoteImageObject();
    img.onload = (): void => {
      Entities.CachedImages.addCachedImage(url, true);
      resolve(true);
    };
    img.onerror = (): void => {
      Entities.CachedImages.addCachedImage(url, false);
      resolve(false);
    };
    img.src = url;
  });
}
